(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/init-choose-club.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/init-choose-club.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.common.init({
    initHandler: function() {
      svs.grassroots.models.my_receivers = new svs.grassroots.models.MyReceivers();
    }
  });

  svs.grassroots.app.start();
})(Backbone, _, svs);


 })(window);